import React from 'react';

const Menu = () => {
  return (
    <div className="menu" id="menu">
      <div className="welcome">
        <h1>Welcome to our diverse menu table</h1>
      </div>
      <div className="grid">
        <div className="project1 projects--medium">
          <div className="menu-card">
            <h1>Vegetable Som Tam</h1>
            <div className="menu-name">
              <p>Salads</p>
            </div>
          </div>
        </div>
        <div className="project2 projects--medium">
          <div className="menu-card">
            <h1>Quattro Formaggi</h1>
            <div className="menu-name">
              <p>Pizzas</p>
            </div>
          </div>
        </div>
        <div className="project3 projects--medium">
          <div className="menu-card">
            <h1>London Broil</h1>
            <div className="menu-name">
              <p>Steaks</p>
            </div>
          </div>
        </div>
        <div className="project4 projects--medium">
          <div className="menu-card">
            <h1>Baked Cheese Filling</h1>
            <div className="menu-name">
              <p>Tacos</p>
            </div>
          </div>
        </div>
        <div className="project5 projects--medium">
          <div className="menu-card">
            <h1>Gordita Crunch</h1>
            <div className="menu-name">
              <p>Stuff Rice</p>
            </div>
          </div>
        </div>
        <div className="project6 projects--medium">
          <div className="menu-card">
            <h1>Rum-Raisin Sundaes</h1>
            <div className="menu-name">
              <p>Desserts</p>
            </div>
          </div>
        </div>
        <div className="project7 projects--medium">
          <div className="menu-card">
            <h1>Naan with Mix-Veg</h1>
            <div className="menu-name">
              <p>Pure Veg.</p>
            </div>
          </div>
        </div>
        <div className="project8 projects--medium">
          <div className="menu-card">
            <h1>Thrill of the Grill</h1>
            <div className="menu-name">
              <p>Burgers</p>
            </div>
          </div>
        </div>
        <div className="project9 projects--medium">
          <div className="menu-card">
            <h1>Treat your Family</h1>
            <div className="menu-name">
              <p>Main Course</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Menu;
